import { render, staticRenderFns } from "./ToolbarApp.vue?vue&type=template&id=6204599c&scoped=true&"
import script from "./ToolbarApp.vue?vue&type=script&lang=js&"
export * from "./ToolbarApp.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarApp.vue?vue&type=style&index=0&id=6204599c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6204599c",
  null
  
)

export default component.exports